import api from "./../api";

const FACEBOOK_API_BASE_URL = "http://localhost:8080/statistiquesFacebook";
const COUNT_POSTS_BASE_URL = "/posts/count";
const COUNT_PAGE_BASE_URL = "/page/count";

class StatistiquesFacebookService {
  /**************
   * Les méthodes de statistiques pour tous les posts de la page
   ****/

  //Afficher le nombre de reactions et likes for all posts
  getReactionsCountForPost() {
    return api.get(FACEBOOK_API_BASE_URL + COUNT_POSTS_BASE_URL + "/reactions");
  }

  //Afficher le nombre de comments for all posts
  getCommentCountForAllPosts() {
    return api.get(FACEBOOK_API_BASE_URL + COUNT_POSTS_BASE_URL + "/comments");
  }

  //Afficher le nombre de vues for all posts
  getInsightCountForAllPosts() {
    return api.get(FACEBOOK_API_BASE_URL + COUNT_POSTS_BASE_URL + "/vues");
  }

  //Afficher le nombre de shares for all posts
  getSharesCountForAllPosts() {
    return api.get(FACEBOOK_API_BASE_URL + COUNT_POSTS_BASE_URL + "/shares");
  }

  /**************
   * Les méthodes de statistiques pour la pages
   ****/
  //Afficher le nombre de followers for page

  getFanCountForPage() {
    return api.get(FACEBOOK_API_BASE_URL + COUNT_PAGE_BASE_URL + "/followers");
  }
}

export default new StatistiquesFacebookService();
